// React bootstrap table next =>
// DOCS: https://react-bootstrap-table.github.io/react-bootstrap-table2/docs/
// STORYBOOK: https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html
import React, { useEffect, useMemo } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../_redux/internationalCalls/internationalCallsActions";
import {
  getSelectRow,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  headerSortingClasses,
} from "../../../../../../_metronic/_helpers";
import * as uiHelpers from "../InternationalCallsUIHelpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { useInternationalCallsUIContext } from "../InternationalCallsUIContext";
import {  useIntl } from "react-intl";
export function InternationalCallsTable() {
  // InternationalCalls UI Context
  const internationalCallsUIContext = useInternationalCallsUIContext();
  const internationalCallsUIProps = useMemo(() => {
    return {
      ids: internationalCallsUIContext.ids,
      setIds: internationalCallsUIContext.setIds,
      queryParams: internationalCallsUIContext.queryParams,
      setQueryParams: internationalCallsUIContext.setQueryParams,
    };
  }, [internationalCallsUIContext]);

  // Getting curret state of internationalCalls list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.internationalCalls }),
    shallowEqual
  );
  const { totalCount, list, listLoading } = currentState;
  const intl = useIntl();
  // InternationalCalls Redux state
  const dispatch = useDispatch();
  useEffect(() => {
    // clear selections list
    internationalCallsUIProps.setIds([]);
    // server call by queryParams
    dispatch(actions.fetchInternationalCalls(internationalCallsUIProps.queryParams));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [internationalCallsUIProps.queryParams, dispatch]);
  // Table columns
  const columns = [
    // {
    //   dataField: "id",
    //   text: "ID",
    //   sort: false,
    //   sortCaret: sortCaret,
    //   headerSortingClasses,
    // },
     {
      dataField: "Image",
      text: intl.formatMessage({ id: "ECOMMERCE.COMMON.Flag" }) ,
      sort: false,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: columnFormatters.ImageColumnFormatter
    },
    {
      dataField: "countryName",
      text: intl.formatMessage({ id: "ECOMMERCE.COMMON.Country" }),
      sort: false,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "iso3",
      text: intl.formatMessage({ id: "ECOMMERCE.COMMON.Code" }),
      sort: false,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "countryCode",
      text:  intl.formatMessage({ id: "ECOMMERCE.COMMON.CCode" }),
      sort: false,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "details",
      text: intl.formatMessage({ id: "ECOMMERCE.COMMON.rate" }),
      sort: false,
      sortCaret: sortCaret,
      formatter: columnFormatters.StatusColumnFormatter,
      headerSortingClasses,
    },
    // {
    //   dataField: "type",
    //   text: "Type",
    //   sort: true,
    //   sortCaret: sortCaret,
    //   formatter: columnFormatters.TypeColumnFormatter,
    // },
    // {
    //   dataField: "action",
    //   text: "Actions",
    //   formatter: columnFormatters.ActionsColumnFormatter,
    //   formatExtraData: {
    //   },
    //   classes: "text-right pr-0",
    //   headerClasses: "text-right pr-3",
    //   style: {
    //     minWidth: "100px",
    //   },
    // },
  ];
  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: internationalCallsUIProps.queryParams.pageSize,
    page: internationalCallsUIProps.queryParams.page,
  };
  return (
    <>
     
         
              <div className="table-wrapper tbcall" style={{ overflowX: "auto", width: "100%" }}>
              <BootstrapTable
                wrapperClasses="table-responsive"
                bordered={false}
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                remote
                keyField="id"
                data={list === null ? [] : list}
                columns={columns}
                defaultSorted={uiHelpers.defaultSorted}
                onTableChange={getHandlerTableChange(
                  internationalCallsUIProps.setQueryParams
                )}
                // selectRow={getSelectRow({
                //   entities,
                //   ids: internationalCallsUIProps.ids,
                //   setIds: internationalCallsUIProps.setIds,
                // })}
               
              >
                <PleaseWaitMessage entities={list} />
                <NoRecordsFoundMessage entities={list} />
              </BootstrapTable>
              </div>
            
         
    </>
  );
}
